import ReactHtmlParser from 'react-html-parser';

const HTMLViewWidget = (data = {}) => {
  return ReactHtmlParser(data.value);
};

export default HTMLViewWidget;
